import Error from '../model/Error';
import Helper from '../../js/accounting/Helper.js';
import axios from 'axios';

export default class ClubInvoiceDunningPdfRepository {
    static createDownloadHistory(clubInvoiceId, dunningLevel) {
        const data = { dunningLevel };
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/club-invoice-dunning-pdfs/${clubInvoiceId}/download-history`, data)
                .then((response) => resolve(response))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static createEmailHistory(clubInvoiceId, dunningLevel) {
        const data = { dunningLevel };
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/club-invoice-dunning-pdfs/${clubInvoiceId}/email-history`, data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static bulkCreateEmailHistory(clubInvoiceIds) {
        const data = { invoices: clubInvoiceIds };
        return new Promise((resolve, reject) => {
            axios
                .post('/club/club-invoice-dunning-pdfs/email-history', data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static bulkCreateDownloadHistory(clubInvoiceIds, collected) {
        const data = { invoices: clubInvoiceIds, collected };
        return new Promise((resolve, reject) => {
            axios
                .post('/club/club-invoice-dunning-pdfs/download-history', data)
                .then((response) => resolve(response))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static downloadDunningPdf(url) {
        return new Promise((resolve, reject) => {
            axios.get(url, { responseType: 'blob' })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', new Helper().getFilenameFromHeaders(response.headers));
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
